import type { DynamicClient } from '@dynamic-labs-sdk/client';
import { getNetworkProviderBuilderRegistry } from '@dynamic-labs-sdk/client/core';

import { createStarknetNetworkProvider } from '../utils/createStarknetNetworkProvider';

export const registerStarknetNetworkProviderBuilder = (
  client: DynamicClient
): void => {
  const networkProviderBuilderRegistry =
    getNetworkProviderBuilderRegistry(client);

  // If the Starknet network provider builder is already registered, return.
  if (networkProviderBuilderRegistry.get().get('STARK')) {
    return;
  }

  networkProviderBuilderRegistry.register({
    builder: createStarknetNetworkProvider,
    chain: 'STARK',
  });
};
